export var BOTPRESS_EVENT_NAVIGATION = 'navigation';
export var BOTPRESS_EVENT_TYPES = [BOTPRESS_EVENT_NAVIGATION];
export function generateBotpressWebEvent(eventType, eventData) {
  return {
    eventType: eventType,
    eventData: eventData
  };
}
export function generateBotpressNavigationWebEvent(location) {
  return generateBotpressWebEvent(BOTPRESS_EVENT_NAVIGATION, {
    url: location.pathname
  });
}
export function generateBotpressSayHiEvent() {
  return generateBotpressWebEvent('glammatic:say-hi', {});
}